<template>
  <section class="space-y-4">
    <h2 class="text-base font-medium dark:text-gray-100">
      {{ t("pages.fitrana.amounts.title") }}
    </h2>

    <div class="space-y-3">
      <div
        v-for="(item, key) in amountTypes"
        :key="key"
        class="flex items-center justify-between p-3 rounded-lg bg-gray-50 dark:bg-gray-800 border border-gray-200 dark:border-gray-700"
      >
        <span class="text-base font-medium text-gray-700 dark:text-gray-200">
          {{ item.label }}
        </span>
        <span
          class="text-base font-semibold text-gray-900 dark:text-gray-100 tabular-nums"
        >
          {{ t("pages.fitrana.amount.currency") }} {{ item.price }}
        </span>
      </div>
    </div>

    <p class="text-xs text-gray-500 dark:text-gray-400 pt-2">
      {{ t("pages.fitrana.amounts.clarification") }}
    </p>
  </section>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { useI18n } from "vue-i18n";

const { t, messages, locale } = useI18n();

const amountTypes = computed(() => {
  return messages.value[locale.value]?.pages?.fitrana?.amounts?.types || {};
});
</script>
